export default __webpack_public_path__ + "static/media/coilsofubahkan.92a7797f.jpg";